/* Shared entrances. Reveal once, preserving each page's scroll choreography. */
(function () {
  'use strict';
  var motion = matchMedia('(prefers-reduced-motion: reduce)');
  var experience = document.body.classList.contains('mnl-page-experience');
  var howItWorks = document.body.classList.contains('mnl-page-how-it-works');
  var insights = document.body.classList.contains('mnl-page-insights');
  var membership = document.body.classList.contains('mnl-page-membership');
  if ((!document.body.classList.contains('mnl-page-index') && !experience && !howItWorks && !insights && !membership) || motion.matches || !window.IntersectionObserver || !Element.prototype.animate) return;

  var textSelector = [
    '.mnl-hero__title', '.mnl-hero__sub',
    '.mnl-pen__eyebrow', '.mnl-pen__title',
    '.mnl-patterns__eyebrow', '.mnl-patterns__title', '.mnl-patterns__label', '.mnl-patterns__caption',
    '.mnl-statement__eyebrow', '.mnl-statement__quote:not([data-mnl-scrolltext])', '.mnl-statement__insight-head', '.mnl-statement__insight-quote',
    '.mnl-app__eyebrow', '.mnl-app__title',
    '.mnl-system__eyebrow', '.mnl-system__title', '.mnl-system__lead', '.mnl-system__mobile-lead',
    '.mnl-system__mantra-top', '.mnl-system__mantra-rest',
    '.mnl-refl__eyebrow', '.mnl-refl__title', '.mnl-refl__note',
    '.mnl-cta__title', '.mnl-cta__text'
  ].join(',');
  var cardSelector = '.mnl-patterns__card, .mnl-system__track > article, .mnl-refl__row, .mnl-statement__banner, .mnl-app__cards';
  if (experience) {
    // Card descriptions appear with their cards; other scenes own their animations.
    textSelector = [
      '.mnl-exp-hero__eyebrow', '.mnl-exp-hero__title', '.mnl-exp-hero__note',
      '.mnl-exp-cards__eyebrow', '.mnl-exp-cards__title',
      '.mnl-exp-writing__kicker', '.mnl-exp-writing__title', '.mnl-exp-writing__lead',
      '.mnl-exp-ritual__kicker', '.mnl-exp-ritual__title', '.mnl-exp-ritual__card-title',
      '.mnl-exp-ritual__caption', '.mnl-exp-ritual__note',
      '.mnl-exp-becoming__kicker', '.mnl-exp-becoming__title', '.mnl-exp-becoming__lead',
      '.mnl-cta__title', '.mnl-cta__text'
    ].join(',');
    cardSelector = '.mnl-exp-cards__card, .mnl-exp-ritual__card';
  }
  if (howItWorks) {
    // Dynamic day panels, color fills, video stops and the moment timeline keep their own choreography.
    textSelector = [
      '.mnl-hiw-hero__title', '.mnl-hiw-hero__lead',
      '.mnl-hiw-days__kicker', '.mnl-hiw-days__title',
      '.mnl-hiw-insight__kicker', '.mnl-hiw-insight__title',
      '.mnl-hiw-insight__lead', '.mnl-hiw-insight__note-side',
      '.mnl-hiw-north__kicker', '.mnl-hiw-north__title',
      '.mnl-hiw-engine__kicker', '.mnl-hiw-engine__title', '.mnl-hiw-engine__description',
      '.mnl-hiw-measure__kicker', '.mnl-hiw-measure__title',
      '.mnl-cta__title', '.mnl-cta__text'
    ].join(',');
    cardSelector = '.mnl-hiw-days__card, .mnl-hiw-insight__card, .mnl-hiw-north__card, .mnl-hiw-engine__cards';
  }
  if (insights) {
    // Growth words, signal meters, rotating quotes and the decision sequence own their motion.
    textSelector = [
      '.mnl-ins-hero__kicker', '.mnl-ins-hero__title', '.mnl-ins-hero__lead',
      '.mnl-ins-reads__kicker', '.mnl-ins-reads__title',
      '.mnl-ins-reads__mobile-head > p', '.mnl-ins-reads__mobile-head > h2',
      '.mnl-ins-signals__kicker', '.mnl-ins-signals__title', '.mnl-ins-signals__lead',
      '.mnl-ins-manimind__kicker', '.mnl-ins-manimind__title', '.mnl-ins-manimind__lead',
      '.mnl-ins-layer__kicker', '.mnl-ins-layer__title', '.mnl-ins-layer__lead',
      '.mnl-ins-layer__shot-title', '.mnl-ins-layer__shot-body', '.mnl-ins-layer__foot',
      '.mnl-ins-compound__kicker', '.mnl-ins-compound__title', '.mnl-ins-compound__lead',
      '.mnl-ins-evidence__kicker', '.mnl-ins-evidence__title', '.mnl-ins-evidence__lead',
      '.mnl-ins-close__title', '.mnl-cta__title', '.mnl-cta__text'
    ].join(',');
    cardSelector = '.mnl-ins-layer__shot';
  }
  if (membership) {
    // Layer panels, tariff values, FAQ answers and the grow color-fill keep their own behavior.
    textSelector = [
      '.mnl-mem-hero__kicker',
      '.mnl-mem-hero__title',
      '.mnl-mem-hero__lead',
      '.mnl-mem-layers__kicker',
      '.mnl-mem-layers__title',
      '.mnl-mem-quote__kicker',
      '.mnl-mem-quote__title',
      '.mnl-mem-quote__foot',
      '.mnl-mem-grow__kicker',
      '.mnl-mem-grow__title',
      '.mnl-mem-plan__kicker',
      '.mnl-mem-plan__title',
      '.mnl-mem-plan__lead',
      '.mnl-mem-plan__other',
      '.mnl-mem-faq__kicker',
      '.mnl-mem-faq__title',
      '.mnl-mem-faq__card-title',
      '.mnl-mem-faq__card-note',
      '.mnl-cta__title',
      '.mnl-cta__text'
    ].join(',');
    cardSelector = '.mnl-mem-layers__card, .mnl-mem-quote__card, .mnl-mem-plan__card, .mnl-mem-faq__list, .mnl-mem-faq__card';
  }
  var heroSelector = '.mnl-hero, .mnl-exp-hero, .mnl-hiw-hero, .mnl-ins-hero, .mnl-mem-hero';
  var jobs = new Map(), running = new Set();
  var mobile = matchMedia('(max-width: 767px)');
  // Patterns are authored in two columns; only column one's first card leads the mobile rail.
  var laterCardSelector = '.mnl-patterns__col--1 .mnl-patterns__card ~ .mnl-patterns__card, .mnl-patterns__col--2 .mnl-patterns__card, .mnl-system__track > article ~ article';
  if (experience) laterCardSelector = '.mnl-exp-cards__card ~ .mnl-exp-cards__card, .mnl-exp-ritual__card ~ .mnl-exp-ritual__card';
  if (howItWorks) laterCardSelector = '.mnl-hiw-insight__card:not(:nth-child(2))';
  if (insights) laterCardSelector = '.mnl-ins-layer__shot ~ .mnl-ins-layer__shot';
  function skipMobileCard(el) {
    return mobile.matches && !!el.closest(laterCardSelector);
  }
  // Start inside the viewport, not at its bottom edge. Pixel margins are
  // intentional: IntersectionObserver percentage margins are based on width.
  var observer, observerHeight = 0, resizeFrame = 0;
  function observeEntrances() {
    observerHeight = window.innerHeight;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var job = jobs.get(entry.target);
        if (job) {
          job.inside = entry.isIntersecting && entry.intersectionRatio >= .1;
          start(job);
        }
      });
    }, { rootMargin: '0px 0px -' + Math.round(observerHeight * .28) + 'px 0px', threshold: .1 });
    jobs.forEach(function (job) {
      if (!job.started && !job.hero) { job.inside = false; observer.observe(job.el); }
    });
  }
  observeEntrances();
  window.addEventListener('resize', function () {
    if (resizeFrame || motion.matches) return;
    resizeFrame = requestAnimationFrame(function () {
      resizeFrame = 0;
      if (window.innerHeight !== observerHeight) observeEntrances();
    });
  }, { passive: true });

  // Remove old whole-block fades BEFORE the core script initializes them.
  document.querySelectorAll(textSelector).forEach(function (el) {
    el.removeAttribute('data-mnl-scrolltext');
    var ancestor = el;
    while (ancestor && !ancestor.classList.contains('shopify-section')) {
      if (!ancestor.matches(cardSelector)) ancestor.removeAttribute('data-mnl-reveal');
      ancestor = ancestor.parentElement;
    }
  });
  document.querySelectorAll(cardSelector).forEach(function (el) { el.removeAttribute('data-mnl-reveal'); });

  function ready(el) {
    var panel = el.closest('[data-mnl-app-panel]');
    return el.getClientRects().length && (!panel || panel.classList.contains('is-active'));
  }
  function wordsFor(el) {
    var replacements = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [], node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() && node.parentElement.getClientRects().length) nodes.push(node);
    }
    var words = [], owners = new Set();
    var prepared = nodes.map(function (node) {
      var parent = node.parentElement;
      var color = getComputedStyle(parent).color;
      var owner = parent, ink = null;
      // A gradient can live on the heading or on an authored line span.
      if (color === 'rgba(0, 0, 0, 0)' || color === 'transparent') {
        while (owner && el.contains(owner)) {
          var style = getComputedStyle(owner);
          if (style.backgroundImage !== 'none' && (style.backgroundClip === 'text' || style.webkitBackgroundClip === 'text')) {
            ink = style.backgroundImage; owners.add(owner); break;
          }
          owner = owner.parentElement;
        }
      }
      return { node: node, color: color, owner: owner, ink: ink };
    });
    prepared.forEach(function (item) {
      var node = item.node, color = item.color, owner = item.owner, ink = item.ink;
      var fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { fragment.appendChild(document.createTextNode(part)); return; }
        var word = document.createElement('mnl-word');
        word.className = 'mnl-home-word'; word.textContent = part;
        word.style.color = color;
        fragment.appendChild(word);
        words.push({ el: word, owner: ink ? owner : null, ink: ink });
      });
      replacements.push({ node: node, parts: Array.from(fragment.childNodes) });
      node.replaceWith(fragment);
    });
    // Read all geometry together, then write paint styles. No per-frame layout reads.
    var scale = el.getBoundingClientRect().width / el.offsetWidth || 1;
    var ownerBoxes = new Map();
    owners.forEach(function (owner) { ownerBoxes.set(owner, owner.getBoundingClientRect()); });
    var fills = words.map(function (word) {
      if (!word.owner) return null;
      var box = ownerBoxes.get(word.owner), r = word.el.getBoundingClientRect();
      return { size: box.width / scale + 'px ' + box.height / scale + 'px', position: -(r.left - box.left) / scale + 'px ' + -(r.top - box.top) / scale + 'px' };
    });
    words.forEach(function (word, i) {
      if (!fills[i]) return;
      word.el.style.backgroundImage = word.ink;
      word.el.style.backgroundSize = fills[i].size;
      word.el.style.backgroundPosition = fills[i].position;
    });
    owners.forEach(function (owner) { owner.classList.add('mnl-home-ink-owner'); });
    return { words: words.map(function (word) { return word.el; }), restore: function () {
      owners.forEach(function (owner) { owner.classList.remove('mnl-home-ink-owner'); });
      replacements.forEach(function (item) {
        var first = item.parts[0];
        if (!first || !first.parentNode) return;
        first.before(item.node);
        item.parts.forEach(function (part) { part.remove(); });
      });
    } };
  }

  // Damped spring sampled once; native animations run without a JS frame loop.
  var springFrames = Array.from({ length: 41 }, function (_, i) {
    var t = i / 40, omega = 10, damping = .86, wd = omega * Math.sqrt(1 - damping * damping);
    var value = 1 - Math.exp(-damping * omega * t) * (Math.cos(wd * t) + damping * omega / wd * Math.sin(wd * t));
    return { offset: t, value: i === 40 ? 1 : value };
  });
  function start(job) {
    if (!job.inside || job.started || !ready(job.el)) return;
    job.started = true; observer.unobserve(job.el);
    // Mobile first screens animate in CSS immediately, before fonts or JS finish loading.
    if (motion.matches || (mobile.matches && job.hero) || skipMobileCard(job.el)) {
      job.el.dataset.homeStarted = '1'; jobs.delete(job.el); return;
    }
    var split = job.text ? wordsFor(job.el) : null;
    var targets = split ? split.words : [job.el];
    var opacities = targets.map(function (el) { return getComputedStyle(el).opacity; });
    var animations = targets.map(function (el, index) {
      var delay = (job.hero ? 350 : 0) + (split ? index * Math.min(36, 450 / Math.max(1, targets.length - 1)) : 0);
      // Individual translate leaves carousel transforms and scaling intact.
      var animation = el.animate(springFrames.map(function (frame) {
        return { offset: frame.offset, opacity: opacities[index] * Math.min(1, frame.offset / .32),
          translate: '0 ' + ((1 - frame.value) * (split ? .42 : 24)).toFixed(4) + (split ? 'em' : 'px') };
      }), { duration: split ? 1000 : 1100, delay: delay, easing: 'linear', fill: 'both' });
      running.add(animation);
      return animation;
    });
    // Expose only after every word has its initial animation frame.
    job.el.dataset.homeStarted = '1';
    Promise.all(animations.map(function (a) { return a.finished.catch(function () {}); })).then(function () {
      animations.forEach(function (a) { a.cancel(); running.delete(a); });
      if (split) split.restore();
      jobs.delete(job.el);
    });
  }
  function init(root) {
    if (!document.documentElement.classList.contains('mnl-home-entrances')) return;
    root.querySelectorAll(textSelector + ',' + cardSelector).forEach(function (el) {
      if (el.dataset.homeEntrance) return;
      el.dataset.homeEntrance = '1';
      if (skipMobileCard(el)) { el.dataset.homeStarted = '1'; return; }
      var hero = !!el.closest(heroSelector);
      var job = { el: el, text: el.matches(textSelector), hero: hero, inside: hero, started: false };
      jobs.set(el, job);
      // First screens start on load, even when their copy is below the scroll trigger.
      if (hero) start(job);
      else observer.observe(el);
    });
  }
  document.fonts.ready.then(function () {
    init(document);
    clearTimeout(window.mnlHomeEntranceFallback);
  }).catch(function () { document.documentElement.classList.remove('mnl-home-entrances'); });
  // A later app panel reveals when selected, rather than while hidden behind the first.
  var panels = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (!record.target.classList.contains('is-active')) return;
      record.target.querySelectorAll('[data-home-entrance]:not([data-home-started])').forEach(function (el) {
        var job = jobs.get(el); if (job) start(job);
      });
    });
  });
  document.querySelectorAll('[data-mnl-app-panel]').forEach(function (panel) { panels.observe(panel, { attributes: true, attributeFilter: ['class'] }); });
  motion.addEventListener('change', function () {
    if (motion.matches) { document.documentElement.classList.remove('mnl-home-entrances'); running.forEach(function (a) { a.finish(); }); observer.disconnect(); }
  });
  mobile.addEventListener('change', function () {
    jobs.forEach(function (job, el) {
      if (job.hero && !job.started) start(job);
      if (!job.started && skipMobileCard(el)) {
        observer.unobserve(el); el.dataset.homeStarted = '1'; jobs.delete(el);
      }
    });
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
